import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

export const MplusRequirements = () => {
  const { t } = useTranslation()

  return (
    <div className={clsx(s.container, 'regular-14')}>
      {t('mplus.mplus_title_not_allow')}

      <ul className={s.list}>
        <li>{t('mplus.mplus_title_not_one')}</li>
        <li>{t('mplus.mplus_title_not_two')}</li>
        <li>{t('mplus.mplus_title_not_three')}</li>
      </ul>
    </div>
  )
}
